<script lang="ts">
  import { createClientStore } from '$lib/stores/createClientStore';
  import { SlideToggle } from '@skeletonlabs/skeleton';

  const request = createClientStore.request;
</script>

<div class="grid grid-cols-1 gap-5 border border-surface-500 p-5 rounded-container-token">
  <div class="label">User Menu Defaults</div>
  {#each $request.menuConfigs as menuConfig}
    <div class="grid grid-cols-12">
      <div class="label col-span-11">
        {menuConfig.name}
      </div>
      <div class="col-span-1">
        <SlideToggle name={menuConfig.name} bind:checked={menuConfig.enabled} active="bg-success-500" background="bg-secondary-600" />
      </div>
    </div>
  {/each}
</div>
